import React from "react";
import HoverIconButton from "components/HoverIconButton";
import { useFormFieldLogicConfig } from "utils/hooks/manifest";
import { COLORS } from "utils/styles";

const FieldLogicStatus = ({ name }) => {
  const logicConfig = useFormFieldLogicConfig({ name });

  return (
    <div className="flex flex-column">
      <label className="f6 mb2 dib fw6">Logic</label>
      <div className="flex flex-row justify-between items-center">
        <div className="f6">{logicConfig.message}</div>
        <div className="dib">
          <HoverIconButton
            color={logicConfig.active ? COLORS.blue : null}
            disabled={logicConfig.disabled}
            tooltip={logicConfig.active ? "Edit logic" : "Set logic"}
            type="logic"
            onClick={logicConfig.setFocus}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldLogicStatus;
